<template>
  <div style="background-color: #f5f5f5;">
    <Topo />
    <b-container>
      <div>
        <b-alert class="text-center pt-4 pb-4" show>
          <h3><b>Página não encontrada!!</b></h3><br />
          <router-link to="/"><i class="fa fa-hand-o-left mr-2" aria-hidden="true"></i>Voltar à página inicial</router-link>
        </b-alert>
      </div>
    </b-container>
  </div>
</template>

<script>
import Topo from '@/components/Topo.vue'

export default {
  name: 'Home',
  components: { Topo }
}
</script>
